export const environment = {
  // Meta Pixel (dataset "Noya Energy"). Public by nature: it is visible in the page.
  metaPixelId: '1741748356518434',
  production: false,
  apiUrl: 'https://api-dev-noya.bramasquare.com' // Update with your backend URL
};
